import React, { useState, useEffect } from 'react';
import { TFI_NEW_URL } from '../constants/constants';

const NewDashboardLink: React.FC = () => {
  const [enableCreditSystem, setEnableCreditSystem] = useState<boolean>(false);

  useEffect(() => {
    const savedValue = localStorage.getItem("enable_credit_system");
    const isEnabled = savedValue === "true";
    setEnableCreditSystem(isEnabled);
  }, []);

  if (!enableCreditSystem || !TFI_NEW_URL) {
    return null;
  }

  return (
    <div className="mb-4">
      <button
        onClick={() => window.open(TFI_NEW_URL, '_blank')}
        className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-200"
      >
        <span className="mr-2">→</span>
        New Dashboard
      </button>
    </div>
  );
};

export default NewDashboardLink;
